import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import { Controller, useForm } from "react-hook-form";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import { useDetailShippingUnit, useUpdateShippingUnit } from "hooks";
import { shippingUnitModeList } from "./utils";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import Select from "react-select";
import { getPhoneValidation } from "constants/validate";

const DetailShippingUnit = props => {
  const { isOpenModal, dataDetail, toggleModal, mode } = props;
  const { t, i18n } = useTranslation(["shippingUnit"]);
  const { addToast } = useToasts();

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const getInitDefaultValues = () => {
    return {
      name: "",
      phone_number: "",
      address: "",
      ward_id: undefined,
      district_id: undefined,
      province_id: undefined,
    };
  };

  const getInitControlFields = () => {
    return {
      display: {
        name: false,
        phone_number: false,
        address: false,
        ward_id: false,
        district_id: false,
        province_id: false,
        btn_save: false,
      },
      disabled: {
        name: false,
        phone_number: false,
        address: false,
        ward_id: false,
        district_id: false,
        province_id: false,
      },
    };
  };
  const [controlFields, setControlFields] = useState(getInitControlFields);

  const schema = yup.object().shape({
    name: yup
      .string()
      .required(t("form.validate.required", { title: t("form.name") }))
      .max(250, t("form.validate.char_max", { max: 250 })),
    address: yup
      .string()
      .required(t("form.validate.required", { title: t("form.address") }))
      .max(250, t("form.validate.char_max", { max: 250 })),
    phone_number: yup
      .string()
      .nullable()
      .required(t("form.validate.required", { title: t("form.phone_number") }))
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    ward_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.ward_id") })),
    district_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.district_id") })),
    province_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.province_id") })),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: getInitDefaultValues(),
  });

  // Detail Job Title
  const onSuccessDetailShippingUnit = data => {
    reset(getInitDefaultValues());
    switch (mode) {
      case shippingUnitModeList.VIEW_SHIPPING_UNIT_DETAIL:
        setValue("name", data.name);
        setValue("phone_number", data.phone_number);
        setValue("address", data.address);
        setValue("ward_id", { label: "test", value: data.ward_code });
        setValue("district_id", { label: "test", value: data.district_code });
        setValue("province_id", { label: "test", value: data.province_code });

        setControlFields({
          display: {
            ...getInitControlFields().display,
            name: true,
            phone_number: true,
            address: true,
            ward_id: true,
            district_id: true,
            province_id: true,
          },
          disabled: {
            ...getInitControlFields().disabled,
            name: true,
            phone_number: true,
            address: true,
            ward_id: true,
            district_id: true,
            province_id: true,
          },
        });
        break;
      case shippingUnitModeList.EDIT_SHIPPING_UNIT_DETAIL:
        setValue("name", data.name, { shouldValidate: true });
        setValue("phone_number", data.phone_number, { shouldValidate: true });
        setValue("address", data.address, { shouldValidate: true });
        setValue(
          "ward_id",
          { label: "test", value: data.ward_code },
          { shouldValidate: true }
        );
        setValue(
          "district_id",
          { label: "test", value: data.district_code },
          { shouldValidate: true }
        );
        setValue(
          "province_id",
          { label: "test", value: data.province_code },
          { shouldValidate: true }
        );

        setControlFields({
          display: {
            ...getInitControlFields().display,
            name: true,
            phone_number: true,
            address: true,
            ward_id: true,
            district_id: true,
            province_id: true,
            btn_save: true,
          },
          disabled: {
            ...getInitControlFields().disabled,
          },
        });
        break;
      default:
        break;
    }
  };
  const {
    isLoading: isLoadingDetail,
    data: shippingUnitDetail,
    refetch: detailShippingUnit,
    remove: resetDetailShippingUnit,
  } = useDetailShippingUnit(
    { shippingUnitId: dataDetail?.shippingUnitId },
    onSuccessDetailShippingUnit
  );

  // Update Shipping Unit
  const onSuccessUpdateShippingUnit = _data => {
    toggleModal(mode);
  };
  const onErrorUpdateShippingUnit = error => {
    if (error.code === 422 && error.fields.length > 0) {
      error.fields.forEach(item => {
        let fieldName = item.field;
        switch (item.field) {
          case "common":
            addToast(item.message, {
              appearance: "error",
              autoDismiss: true,
            });
            break;
          default:
            break;
        }
        setError(fieldName, {
          type: "manual",
          message: formConvertErrorMessage(item.message, t),
        });
      });
    }
    if (error.code !== 422) {
      toggleModal(mode);
    }
  };
  const { isLoading: isLoadingUpdate, mutate: updateShippingUnit } =
    useUpdateShippingUnit(
      onSuccessUpdateShippingUnit,
      onErrorUpdateShippingUnit
    );

  useEffect(() => {
    if (!isOpenModal) {
      resetDetailShippingUnit();
      setIsDetail(false);
      setControlFields(getInitControlFields());
      reset(getInitDefaultValues());
    }
  }, [isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.shippingUnitId && !isDetail) {
        detailShippingUnit();
        setIsDetail(true);
      }
    }
  }, [dataDetail, detailShippingUnit, isDetail, isOpenModal]);

  const onSubmit = values => {
    const data = getValues();

    switch (mode) {
      case shippingUnitModeList.EDIT_SHIPPING_UNIT_DETAIL:
        updateShippingUnit({
          shippingUnitId: shippingUnitDetail?.id,
          data: {
            name: data.name,
            phone_number: data.phone_number,
            address: data.address,
            district_id: data.district_id.value,
            province_id: data.province_id.value,
            ward_id: data.ward_id.value,
          },
        });
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <ModalHeader toggle={toggleModal}>
          {mode === shippingUnitModeList.VIEW_SHIPPING_UNIT_DETAIL &&
            `${t("title.detail")}`}
          {mode === shippingUnitModeList.EDIT_SHIPPING_UNIT_DETAIL &&
            `${t("title.edit")}`}
        </ModalHeader>
        {isLoadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="6"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Row className="row-cols-1 row-cols-md-2">
                {controlFields.display.name && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="name">
                        {t("form.name")} <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled={controlFields.disabled.name}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "name"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.name"),
                        })}
                        {...register("name")}
                      />
                      {errors.name && (
                        <MessageFormValidate error={errors.name.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.phone_number && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="phone_number">
                        {t("form.phone_number")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled={controlFields.disabled.phone_number}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "phone_number"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.phone_number"),
                        })}
                        {...register("phone_number")}
                      />
                      {errors.phone_number && (
                        <MessageFormValidate
                          error={errors.phone_number.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.address && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="address">
                        {t("form.address")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <input
                        disabled={controlFields.disabled.address}
                        type="text"
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "address"
                        )}`}
                        placeholder={t("placeholder.enter", {
                          title: t("form.address"),
                        })}
                        {...register("address")}
                      />
                      {errors.address && (
                        <MessageFormValidate error={errors.address.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.ward_id && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="ward_id">
                        {t("form.ward_id")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Controller
                        control={control}
                        name="ward_id"
                        render={({ field }) => (
                          <Select
                            {...field}
                            isDisabled={controlFields.disabled.ward_id}
                            placeholder={t("placeholder.select", {
                              title: t("form.ward_id"),
                            })}
                            options={[
                              { value: "11001", label: "Phường 7" },
                              { value: "11002", label: "Phường 1" },
                              { value: "11003", label: "Phường 8" },
                            ]}
                            classNamePrefix="select2-selection"
                          />
                        )}
                      />
                      {errors.ward_id && (
                        <MessageFormValidate error={errors.ward_id.message} />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.district_id && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="district_id">
                        {t("form.district_id")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Controller
                        control={control}
                        name="district_id"
                        render={({ field }) => (
                          <Select
                            {...field}
                            isDisabled={controlFields.disabled.district_id}
                            placeholder={t("placeholder.select", {
                              title: t("form.district_id"),
                            })}
                            options={[
                              { value: "552", label: "Quận 1" },
                              { value: "553", label: "Quận 12" },
                              { value: "560", label: "Quận Phú Nhuận" },
                            ]}
                            classNamePrefix="select2-selection"
                          />
                        )}
                      />
                      {errors.district_id && (
                        <MessageFormValidate
                          error={errors.district_id.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                )}

                {controlFields.display.province_id && (
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="province_id">
                        {t("form.province_id")}{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Controller
                        control={control}
                        name="province_id"
                        render={({ field }) => (
                          <Select
                            {...field}
                            isDisabled={controlFields.disabled.province_id}
                            placeholder={t("placeholder.select", {
                              title: t("form.province_id"),
                            })}
                            options={[
                              { value: "1", label: "Thành phố Hà Nội" },
                              { value: "50", label: "Thành phố Hồ Chí Minh" },
                            ]}
                            classNamePrefix="select2-selection"
                          />
                        )}
                      />
                      {errors.province_id && (
                        <MessageFormValidate
                          error={errors.province_id.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                )}
              </Row>
            </ModalBody>
            <ModalFooter>
              <Row className="justify-content-end">
                {controlFields.display.btn_save && (
                  <Col className="col-auto">
                    <Button
                      color="primary"
                      className="btn-label"
                      type="button"
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                      disabled={isLoadingUpdate}
                    >
                      <i className="bx bx-save label-icon"></i>
                      {t("form.update")}
                    </Button>
                  </Col>
                )}
              </Row>
            </ModalFooter>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
};

DetailShippingUnit.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
};

DetailShippingUnit.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default DetailShippingUnit;
